module.exports = __webpack_public_path__ + "img/games-18.7beb8157.jpg";